module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/pdf-file-aeb30c8a13c7ab38ccabb05082cac57b.svg";